<template>
  <validation-observer
    ref="sendMessage"
    #default="{ invalid }"
  >
    <b-form @submit.prevent="saveWebhook">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$t('webhook url')"
            label-for="webhook-url"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('webhook url')"
              vid="url"
            >
              <b-form-input
                id="webhook-url"
                v-model="webhook"
                :placeholder="$t('webhook url')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- submit -->
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            :disabled="spin || invalid"
          >
            <b-spinner
              v-if="spin"
              small
            />
            {{ $t("save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'WebhookForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    account: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      webhook: '',
      spin: false,
    }
  },
  created() {
    this.$http.get(`accounts/${this.account.id}/webhooks`).then(({ data }) => {
      if (data.length) this.webhook = data[0].url
    })
  },
  methods: {
    saveWebhook() {
      this.$refs.sendMessage.validate().then(success => {
        if (success) {
          this.spin = true
          this.$http.post(`accounts/${this.account.id}/webhooks`,
            {
              url: this.webhook,
            }).then(({ message }) => {
            this.spin = false
            this.showSuccessNotification(message)
          }).catch(() => {
            this.spin = false
          })
        }
      })
    },
  },
}
</script>
